module.exports = {
  "/": {
    "name": "homepage",
    "success": {
      "homepage loaded": [
        "HOMEPAGE_LOAD"
      ]
    },
    "error": [
      "HOMEPAGE_LOAD_FAILURE"
    ]
  },
  "/courses": {
    "name": "catalog page",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/page/:pageNumber": {
    "name": "catalog page with pagination",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/marketing": {
    "name": "catalog page with marketing filter",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/marketing/page/:pageNumber": {
    "name": "catalog page with marketing filter and pagination",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/sales": {
    "name": "catalog page with sales filter",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/sales/page/:pageNumber": {
    "name": "catalog page with sales filter and pagination",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/service": {
    "name": "catalog page with service filter",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/service/page/:pageNumber": {
    "name": "catalog page with service filter and pagination",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/software": {
    "name": "catalog page with software filter",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/courses/software/page/:pageNumber": {
    "name": "catalog page with software filter and pagination",
    "success": {
      "catalog results loaded": [
        "CATALOG_PAGE_LOAD",
        "CATALOG_RESULTS_LOADED"
      ],
      "catalog empty page loaded": [
        "CATALOG_PAGE_LOAD_EMPTY"
      ]
    },
    "error": [
      "CATALOG_PAGE_LOAD_FAILURE",
      "CATALOG_FILTERS_LOAD_FAILURE"
    ]
  },
  "/certification-overview": {
    "name": "certification overview page",
    "success": {
      "certification overview page loaded": [
        "CERTIFICATION_OVERVIEW_PAGE_LOAD"
      ]
    },
    "error": [
      "CERTIFICATION_OVERVIEW_PAGE_LOAD_FAILURE"
    ]
  },
  "/courses/:pagePath": {
    "name": "course landing page",
    "success": {
      "course landing page loaded": [
        "COURSE_LANDING_PAGE_LOAD"
      ],
      "course landing page not found": [
        "COURSE_LANDING_PAGE_NOT_FOUND"
      ],
      "course landing page forbidden": [
        "COURSE_LANDING_PAGE_FORBIDDEN"
      ]
    },
    "error": [
      "COURSE_LANDING_PAGE_LOAD_FAILURE"
    ]
  },
  "/lessons/:pagePath": {
    "name": "lesson landing page",
    "success": {
      "lesson landing page loaded": [
        "LESSON_LANDING_PAGE_LOAD"
      ],
      "lesson landing page not found": [
        "LESSON_LANDING_PAGE_NOT_FOUND"
      ],
      "lesson landing page forbidden": [
        "LESSON_LANDING_PAGE_FORBIDDEN"
      ]
    },
    "error": [
      "LESSON_LANDING_PAGE_LOAD_FAILURE"
    ]
  },
  "/videos/:videoId": {
    "name": "video landing page",
    "success": {
      "video landing page loaded": [
        "VIDEO_LANDING_PAGE_LOAD"
      ],
      "video landing page not found": [
        "VIDEO_LANDING_PAGE_NOT_FOUND"
      ],
      "video landing page forbidden": [
        "VIDEO_LANDING_PAGE_FORBIDDEN"
      ]
    },
    "error": [
      "VIDEO_LANDING_PAGE_LOAD_FAILURE"
    ]
  }
};